import { RouterProvider } from '@tanstack/react-router';

import { ModalDownloadManager } from '@/features/download-progress/modal-download-progress';

import { router } from './routes/router';
import { useStore } from './stores';

export default function App() {
  const authStore = useStore();

  return (
    <>
      <RouterProvider
        router={router}
        context={{
          authStore,
        }}
      />

      <ModalDownloadManager />
    </>
  );
}
